// extracted by mini-css-extract-plugin
export var afterFooter = "index-module--afterFooter--ec04b";
export var description = "index-module--description--30316";
export var footer = "index-module--footer--33e18";
export var groups = "index-module--groups--b43fe";
export var inner = "index-module--inner--44543";
export var link = "index-module--link--5fe34";
export var logo = "index-module--logo--c3935";
export var title = "index-module--title--feab9";
export var wrapper = "index-module--wrapper--3043e";